<script lang="ts">
	import type { PageProps } from "./$types";
	import { YouTubeSection } from "#lib/web-ui/blocks/index.js";

	let { data }: PageProps = $props();
</script>

<svelte:head>
	<title>Real Estate Investment Videos | Fergmar Capital</title>
	<meta
		name="description"
		content="Watch Fergmar Capital break down real estate deal analysis, syndication strategies, portfolio performance, and current market offerings."
	/>
	<meta property="og:title" content="Real Estate Investment Videos | Fergmar Capital" />
	<meta
		property="og:description"
		content="Watch deal analysis, syndication strategies, portfolio performance, and market offering breakdowns from Fergmar Capital."
	/>
	<meta name="twitter:title" content="Real Estate Investment Videos | Fergmar Capital" />
	<meta
		name="twitter:description"
		content="Watch deal analysis, syndication strategies, and market offering breakdowns from Fergmar Capital."
	/>

	{@html `<script type="application/ld+json">${JSON.stringify({
		"@context": "https://schema.org",
		"@type": "ItemList",
		name: "Fergmar Capital Real Estate Investment Videos",
		url: "https://fergmarcapital.com/media/youtube",
		numberOfItems: data.youtubeVideos.length,
		itemListElement: data.youtubeVideos.slice(0, 10).map((video, i) => ({
			"@type": "ListItem",
			position: i + 1,
			item: {
				"@type": "VideoObject",
				name: video.title,
				description: video.title,
				thumbnailUrl: video.thumbnailUrl,
				uploadDate: video.publishedAt,
				embedUrl: `https://www.youtube.com/embed/${video.videoId}`,
				publisher: { "@type": "Organization", name: "Fergmar Capital" }
			}
		}))
	})}</script>`}
</svelte:head>

<h1 class="sr-only">Real Estate Investment Videos from Fergmar Capital</h1>

<YouTubeSection
	label="Video Insights"
	title="Our Strategy in Action"
	subtitle="Watch our team break down deal analysis, portfolio performance, and market offerings firsthand."
	videos={data.youtubeVideos}
	channelUrl="https://www.youtube.com/@FergmarCapital"
	theme="light"
/>
